import { VPNService } from '../service/luigiNodes/vpn.service';
import { potentialVPNResourceLoadable } from '../utilities/potential-vpn-resource-loadable.helper';

export function checkIfInVPN(vpnService: VPNService) {
  return async (): Promise<void> => {
    potentialVPNResourceLoadable('https://avatars.wdf.sap.corp').then(
      (inVPN: boolean) => {
        vpnService.setVPN(inVPN);
      },
    );
  };
}
